export default "__VITE_ASSET__CgDFKWrD__"